var weight = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};
var fontWeight = function fontWeight(name) {
  return "font-weight: " + (weight[name] ? weight[name] : weight.normal) + ";";
};

export { fontWeight, weight };
